<template>
  <div id="WelcomeDialogStage">
    <el-dialog
      title="Welcome"
      :visible.sync="dialogVisible"
      width="90%">
      <img src="/img/icons/favicon_192-192.png" width="80px" height="80px" alt="Picture of an adult carrying a small child away.">
      <div align="left">
        <p>A criminal record can make it hard to find a job or rent a home. Come see if you can expunge or seal your criminal record. Sealing and expunging stops the public from viewing your record. Florida Fresh Start helps people with adult or juvenile arrests.</p>
        <p>It takes 5 minutes to brighten your future.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">Let's Go!</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Button, Dialog } from 'element-ui'

export default {
  data: function () {
    return {
      dialogVisible: true
    }
  },

  components: {
    'el-dialog': Dialog,
    'el-button': Button
  },

  mounted: function () {
  }
}
</script>

<style scoped>
#WelcomeDialogStage >>> .el-dialog__body {
  padding-top: 5px;
}

#WelcomeDialogStage >>> .el-dialog {
  max-width: 600px;
}
</style>
